import { Mountain } from 'lucide-react'
import type { ComponentProps } from 'react'

/**
 * The Warike brand mark: lucide's "mountain".
 *
 * Warike is a Quechua word for a hidden place worth finding, so the mark is a
 * peak — the same glyph apps/admin/public/favicon.svg serves, so the tab and
 * the chrome read as one thing. Wrapped in a named component rather than
 * importing `Mountain` at each call site so the mark has ONE definition:
 * swapping the brand glyph is a one-line change here, and a reader can tell
 * the brand mark apart from a decorative mountain icon.
 */
export function WarikeMark(props: ComponentProps<typeof Mountain>) {
  return <Mountain aria-hidden {...props} />
}

/**
 * The mark's outline, for the one place the band has to paint THROUGH the glyph
 * rather than tint it: the brand lockup's shimmer (a stroke drawn in
 * currentColor cannot be clipped to a gradient). Same path and stroke as
 * `WarikeMark` renders — brand-loader.render.test.tsx pins the two together, so
 * swapping the glyph above without this path fails a test.
 */
export const WARIKE_MARK_PATH = 'm8 3 4 8 5-5 5 15H2L8 3z'

/** The outline as a CSS mask image (a data URL: no request, no flash). */
export const warikeMarkMask = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${WARIKE_MARK_PATH}"/></svg>`,
)}")`
